/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
export function setTokenToLocalStorage(token) {
    localStorage.setItem('token', token);
}
export function getTokenFromLocalStorage() {
    return localStorage.getItem('token') || '';
}
export function setUserToLocalStorage(user) {
    if (user === null) {
        localStorage.setItem('user', '');
    }
    localStorage.setItem('user', JSON.stringify(user));
}
export function getUserFromLocalStorage() {
    var userString = localStorage.getItem('user') || '{"roles": []}';
    return JSON.parse(userString);
}
export function tokenHasExpired() {
    var token = getTokenFromLocalStorage();
    if (!token)
        return true;
    try {
        var user = getUserFromLocalStorage();
        var expires_at = Date.parse(user.expires_at);
        return expires_at < Date.now();
    }
    catch (e) {
        return true;
    }
}
